import axios from '../utils/axios';

export const getChats = async (userId) =>
  await axios.get(`${process.env.REACT_APP_API}/user/messages/${userId}`);

export const deleteChat = async (messagesWith) =>
  await axios.delete(`${process.env.REACT_APP_API}/message/${messagesWith}`);